import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const categories = [
  { name: '热血', count: '1.8万部', cover: '/images/categories/cat-1.webp' },
  { name: '恋爱', count: '2.2万部', cover: '/images/categories/cat-2.webp' },
  { name: '悬疑', count: '1.2万部', cover: '/images/categories/cat-3.webp' },
  { name: '奇幻', count: '1.5万部', cover: '/images/categories/cat-4.webp' },
  { name: '校园', count: '1.1万部', cover: '/images/categories/cat-5.webp' },
  { name: '治愈', count: '1.4万部', cover: '/images/categories/cat-6.webp' },
  { name: '搞笑', count: '1.6万部', cover: '/images/categories/cat-7.webp' },
  { name: '科幻', count: '0.9万部', cover: '/images/categories/cat-8.webp' },
  { name: '冒险', count: '1.0万部', cover: '/images/categories/cat-9.webp' },
  { name: '日常', count: '1.3万部', cover: '/images/categories/cat-10.webp' },
  { name: '武侠', count: '0.8万部', cover: '/images/categories/cat-11.webp' },
  { name: '异世界', count: '1.7万部', cover: '/images/categories/cat-12.webp' },
];

function ScrollReveal({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'} ${className}`}>
      {children}
    </div>
  );
}

export default function Categories() {
  return (
    <div className="min-h-screen bg-pink-50/50 pt-20 relative overflow-hidden">
      {/* 网点纹理背景 */}
      <div className="absolute inset-0 halftone-pink pointer-events-none" />
      <div className="absolute inset-0 line-grid-neutral pointer-events-none" />

      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 py-20 md:py-28">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-14 md:mb-20">
              {/* 方框序号徽章 + eyebrow */}
              <div className="flex items-center justify-center gap-3 mb-5">
                <span className="inline-flex items-center justify-center w-9 h-9 rounded-lg border-2 border-gray-900 bg-white font-serif text-sm font-bold text-pink-500 shadow-[3px_3px_0_0_#ff9db8]">
                  02
                </span>
                <span className="text-xs tracking-[0.25em] text-gray-500 font-medium uppercase">
                  Categories
                </span>
              </div>

              {/* 对话气泡标签 */}
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-lg border-2 border-gray-900 bg-white text-pink-600 text-sm font-bold shadow-[3px_3px_0_0_#ff9db8] mb-6 relative">
                漫画分类
                <span className="absolute -bottom-[7px] left-8 w-3 h-3 bg-white border-r-2 border-b-2 border-gray-900 rotate-45" />
              </div>

              <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
                全品类漫画，一站读尽
                <span className="block mt-3 mx-auto w-28 h-1.5 bg-pink-400 rounded-full" />
              </h1>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                天天漫画收录12大品类、10万+部优质作品，无论你偏好何种题材，都能在这里找到心仪之作。
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {categories.map((cat, i) => (
              <ScrollReveal key={cat.name}>
                <div className="group cursor-pointer">
                  <div className="relative rounded-lg overflow-hidden border-2 border-gray-900 bg-white shadow-[5px_5px_0_0_#ff9db8] transition-all duration-200 group-hover:shadow-[5px_5px_0_0_#1a1a1a] group-hover:-translate-y-1.5">
                    {/* 封面 */}
                    <div className="relative aspect-[3/4] overflow-hidden border-b-2 border-gray-900">
                      <img
                        src={cat.cover}
                        alt={cat.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      {/* 编号方框 */}
                      <div className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center border-2 border-gray-900 bg-gray-900 text-white font-serif font-bold text-base shadow-[2px_2px_0_0_#ff9db8]">
                        {String(i + 1).padStart(2, '0')}
                      </div>
                      {/* hover 箭头 */}
                      <div className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-lg border-2 border-gray-900 bg-white text-gray-900 shadow-[2px_2px_0_0_#ff9db8] opacity-0 group-hover:opacity-100 transition-all duration-200 -translate-x-1 group-hover:translate-x-0">
                        <i className="ri-arrow-right-line text-base" />
                      </div>
                      {/* hover 蒙层 */}
                      <div className="absolute inset-0 bg-gray-900/70 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <span className="px-4 py-1.5 rounded-lg border-2 border-white bg-white text-gray-900 text-xs font-bold whitespace-nowrap">
                          进入分类
                        </span>
                      </div>
                    </div>

                    {/* 信息区 */}
                    <div className="p-4">
                      <h3 className="font-serif font-bold text-gray-900 text-base md:text-lg group-hover:text-pink-500 transition-colors leading-tight">
                        {cat.name}
                      </h3>
                      <p className="mt-1.5 text-xs text-gray-500 flex items-center gap-1">
                        <i className="ri-book-open-line" />
                        {cat.count} 部作品
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal>
            <div className="text-center mt-16 md:mt-20">
              <p className="text-gray-500 text-sm mb-6">
                找不到心仪的分类？试试天天漫画的智能推荐，让好作品主动找到你。
              </p>
              <Link
                to="/download"
                className="btn-comic-solid"
              >
                <i className="ri-download-2-line" /> 立即下载体验
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </div>
  );
}